import {CommonModule} from '@angular/common';
import {MaterialModule} from '../../../material/material.module';
import {NgModule} from '@angular/core';
import {UploadAttachmentComponent} from './upload-attachment.component';

@NgModule({
  declarations: [UploadAttachmentComponent],
  imports: [
    CommonModule,
    MaterialModule
  ],
  exports: [UploadAttachmentComponent]
})

export class UploadAttachmentModule {
}
